<template>
  <div class="btn-group">
    <template v-if="rowData.status != 2">
      <div v-if="button_list.includes(14)" class="word-ative">
        <img src="@/assets/image/bargin/refund.png" alt="" />
        <span>正在验号...</span>
      </div>
      <el-button
        class="btn-giveup"
        :disabled="disabled"
        v-preventReClick="1000"
        size="mini"
        v-if="button_list.includes(1)"
        @click.stop="eventEmit('give_up')"
        >放弃</el-button
      >
      <el-button
        :disabled="disabled"
        v-preventReClick="1000"
        class="btn-pay w-110"
        v-if="button_list.includes(2)"
        @click.stop="payNow"
        >立即付款</el-button
      >
      <el-button
        @click.stop="eventEmit('bid')"
        :disabled="disabled"
        v-preventReClick="1000"
        v-if="button_list.some((item) => item === 3 || item === 6)"
        :class="[button_list.includes(6) ? 'btn-pay' : 'btn-price']"
        >出价</el-button
      >
      <el-tooltip
        v-if="button_list.includes(4)"
        class="item"
        effect="dark"
        content="该价格为卖家已同意的最低价格"
        placement="top-end"
      >
        <el-button
          class="button w-110 btn-pay"
          :disabled="disabled"
          v-preventReClick="1000"
          @click.stop="floorBuy"
        >
          <div class="floor_buy">底价购买</div>
          <div class="floor_price">底价：¥{{ rowData.new_reserve_price }}</div>
        </el-button>
      </el-tooltip>
      <el-button
        v-if="button_list.includes(12)"
        class="button w-110 btn-disabled"
      >
        <div class="floor_buy">底价购买</div>
        <div class="floor_price">底价：¥{{ rowData.new_reserve_price }}</div>
      </el-button>
      <el-button
        v-if="button_list.includes(5)"
        class="button w-110 btn-pay"
        :disabled="disabled"
        v-preventReClick="1000"
        @click.stop="searchFloor"
      >
        <div class="floor_buy">查看底价</div>
        <div class="floor_price">底价：？？？</div>
      </el-button>
      <el-button
        class="btn-pay w-110"
        :disabled="disabled"
        v-preventReClick="1000"
        v-if="button_list.includes(7)"
        @click.stop="eventEmit('payRest')"
        >付尾款</el-button
      >
      <el-button
        :disabled="disabled || rowData.last_urge_timestamp>0"
        v-preventReClick="1000"
        v-if="button_list.some((item) => item === 8 || item === 9)"
        :class="[button_list.includes(8) ? 'btn-price' : 'btn-pay',rowData.last_urge_timestamp>0?'btn-urge-disabled':'']"
        @click.stop="urge"
        >催促
        <template v-if="rowData.last_urge_timestamp>0">
          <count-down class="count_down" :end-time="rowData.last_urge_timestamp" :start-time="getNowTime" :key="rowData.id" format="ms" @countDownChange="$emit('nextUrgeTimeChange')" @timeChange="(val) => (time = val)">
          <template v-if="time">
               ({{ time }})
          </template>
        </count-down>
        </template>
      </el-button>
      <el-button
        v-if="button_list.some((item) => item === 10 || item === 11)"
        :class="[button_list.includes(10) ? 'btn-pay' : 'btn-disabled']"
        @click.stop="agree"
        :disabled="disabled"
        v-preventReClick="1000"
        >同意</el-button
      >
      <el-button
        :disabled="disabled"
        v-preventReClick="1000"
        v-if="button_list.includes(13)"
        class="btn-pay w-110"
        @click.stop="eventEmit('apply_check')"
        >申请验号</el-button
      >
      <!-- <el-button
        v-if="button_list.includes(18)"
        class="btn-price"
        @click="afterSale"
        >售后</el-button
      > -->
      <el-button
        :disabled="disabled"
        v-preventReClick="1000"
        v-if="button_list.some((item) => item === 15 || item === 16)"
        :class="['w-110', button_list.includes(16) ? 'btn-price' : 'btn-pay']"
        @click.stop="eventEmit('check_res')"
        >{{ "验号报告" }}</el-button
      >
      <el-button
        :disabled="disabled"
        v-preventReClick="1000"
        v-if="button_list.includes(17)"
        class="btn-pay"
        @click="goGroup"
        >进群</el-button
      >
    </template>
    <template v-else>
      <el-button
        :disabled="disabled"
        v-preventReClick="1000"
        v-if="button_list.some((item) => item === 15 || item === 16)"
        :class="[
          'w-110 mr-10',
          button_list.includes(16) ? 'btn-price' : 'btn-pay',
        ]"
        @click.stop="eventEmit('check_res')"
        >{{ "验号报告" }}</el-button
      >
      <el-button
        :disabled="disabled"
        v-preventReClick="1000"
        v-if="button_list.includes(19)"
        class="w-110 btn-pay"
        @click.stop="eventEmit('check_res')"
        >验号详情</el-button
      >
      <el-button
        :disabled="disabled"
        v-preventReClick="1000"
        v-if="button_list.includes(21)"
        class="btn-pay w-110"
        @click.stop="goLiuda"
        >去逛逛</el-button
      >
      <el-button
        :disabled="disabled"
        v-preventReClick="1000"
        v-if="button_list.includes(20)"
        class="btn-pay w-110"
        @click.stop="bargainAgin"
        >重新求降价</el-button
      >
    </template>
  </div>
</template>

<script>
import Bus from "@/util/eventBus";
import countDown from "@/components/countDown";
import {
  earnestAgree,
  checkFloorPrice,
  buyerUrge,
  payPrepare,
  earnestFloor,
  paymentPrepare,
} from "@/request/API";
export default {
  components: {
    countDown
  },
  props: {
    rowData: {
      type: Object,
      default: () => ({}),
    },
    button_list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      disabled: false,
      time: "",
    };
  },
  computed: {
    getNowTime() {
      return new Date().getTime() / 1000;
    },
  },
  methods: {
    /**
     * @description: 去逛逛
     * @return {*}
     */
    goLiuda(){
      let routeUrl = this.$router.resolve({
        name: 'SelectGame',
        query: {
          game_id: this.rowData.game_id,
          game_alias:
            this.rowData.game_id == "26" ? "yuanshen5" : "games",
        },
      });
      window.open(routeUrl.href, '_blank');
    },
    /**
     * @description: 重新求降价
     * @return {*}
     */
    bargainAgin() {
      this.$router.push({
        name: 'GameDetails',
        query:{
          game_id:this.rowData.game_id,
          id:this.rowData.product_id,
          source_page: this.$route.path.slice(1)
        }
      })
    },
    eventEmit(type) {
      var openType = type;
      if (openType == "give_up") {
        // 放弃议价已付定金 abandon_purchase
        // 放弃账号已付尾款 abandon_bargin
        // pay_time 定金支付时间
        // tail_order_pay_time 尾款支付时间
        openType =
          this.rowData.pay_time && this.rowData.tail_order_pay_time
            ? "abandon_purchase"
            : "abandon_bargin";
      }
      Bus.$emit("btnOperation", this.rowData, openType);
    },
    floorBuy() {
      earnestFloor({ order_id: this.rowData.id })
        .then((res) => {
          let timer = setTimeout(() => {
            clearTimeout(timer);
            // 订单选择包赔页
            Bus.$emit("reFresh");
            this.openNewPage("OnlineDeal");
          }, 2000);
        })
        .catch((err) => {
          // 商品二次编辑   下架  改价 10012 跳详情页 10013 跳列表页
          if (err?.code === 10012 || err?.code === 10013) {
            Bus.$emit("productChange", {
              error_code: err.code,
              ...this.rowData,
            });
          }
          this.$message({
            message: err.msg,
            customClass: "counteroffer-msg",
          });
        })
    },
    // // 售后
    // afterSale() {
    //   this.$openIM({
    //     game_id: item.game_id,
    //     room_id: res.data.group_room_id,
    //     gameAlias: "htmg",
    //     im_type: res.data.im_type,
    //   });
    //   Bus.$emit("closeDialog");
    // },
    // 催一催
    urge() {
      buyerUrge({ order_id: this.rowData.id })
        .then((res) => {
          this.$message({
            message: res.msg,
            customClass: "counteroffer-msg",
          });
          Bus.$emit("closeDialog");
          Bus.$emit("reFresh");
        })
        .catch((err) => {
          // 商品二次编辑   下架  改价 10012 跳详情页 10013 跳列表页
          if (err?.code === 10012 || err?.code === 10013) {
            Bus.$emit("productChange", {
              error_code: err.code,
              ...this.rowData,
            });
          }
          this.$message({
            message: err.msg,
            customClass: "counteroffer-msg",
          });
        });
    },
    // 付尾款
    // payRest() {
    //   payPrepare({ order_id: this.rowData.id })
    //     .then((res) => {
    //       Bus.$emit("closeDialog");
    //       if (res.data.order_amount > 0) {
    //         this.openNewPage("MethodOfPayment", "1", res.data);
    //       } else {
    //         this.openNewPage("OnlineDeal");
    //       }
    //     })
    //     .catch((err) => {
    //       // 商品二次编辑   下架  改价 10012 跳详情页 10013 跳列表页
    //       if (err?.code === 10012 || err?.code === 10013) {
    //         Bus.$emit("productChange", {
    //           error_code: err.code,
    //           ...this.rowData,
    //         });
    //       }
    //       this.$message({
    //         message: err.msg,
    //         customClass: "counteroffer-msg",
    //       });
    //     });
    // },
    //同意
    agree() {
      if (this.button_list.includes(11)) return;
      earnestAgree({ order_id: this.rowData.id })
        .then((res) => {
          // 打开弹窗
          Bus.$emit("btnOperation", this.rowData, "agree");
          //  刷新列表
          Bus.$emit("reFresh");
        })
        .catch((err) => {
          // 商品二次编辑   下架  改价 10012 跳详情页 10013 跳列表页
          if (err?.code === 10012 || err?.code === 10013) {
            Bus.$emit("productChange", {
              error_code: err.code,
              ...this.rowData,
            });
          }
          this.$message({
            message: err.msg,
            customClass: "counteroffer-msg",
          });
        });
    },
    // 查看底价
    searchFloor() {
      if (this.rowData.new_reserve_price === "0") {
        return this.$message({
          message: "底价暂未生成",
          customClass: "counteroffer-msg",
        });
      }
      checkFloorPrice({ order_id: this.rowData.id })
        .then((res) => {
          this.$emit("reFresh", { id: this.rowData.id });
        })
        .catch((err) => {
          // 商品二次编辑   下架  改价 10012 跳详情页 10013 跳列表页
          if (err?.code === 10012 || err?.code === 10013) {
            Bus.$emit("productChange", {
              error_code: err.code,
              ...this.rowData,
            });
          }
          this.$message({
            message: err.msg,
            customClass: "counteroffer-msg",
          });
        })
    },
    // 进群
    goGroup() {
      this.$openIM({
        im_type: 3,
        roomId: this.rowData.group_room_id,
      });
      Bus.$emit("closeDialog");
    },
    // 立即付款
    payNow() {
      paymentPrepare({ order_id: this.rowData.id })
        .then((res) => {
          // 收银台 支付定金
          this.openNewPage("MethodOfPayment", "3");
          Bus.$emit("closeDialog");
        })
        .catch((err) => {
          // 商品二次编辑   下架  改价 10012 跳详情页 10013 跳列表页
          if (err?.code === 10012 || err?.code === 10013) {
            Bus.$emit("productChange", {
              error_code: err.code,
              ...this.rowData,
            });
          }
          this.$message({
            message: err.msg,
            customClass: "counteroffer-msg",
          });
        });
    },
    openNewPage(name, type, data) {
      var query;
      // type 1账号  尾款   3诚意金
      switch (name) {
        case "MethodOfPayment":
          query = {
            type,
            id: data ? data.product_id : this.rowData.product_id,
            orderid: data ? data.product_order_id : this.rowData.id,
            gameid: data ? data.game_id : this.rowData.game_id,
            amount: data ? data.order_amount : this.rowData.earnest_amount,
            earnest_order_id: this.rowData.id,
          };
          break;
        case "OnlineDeal":
          query = {
            id: this.rowData.product_id,
            game_id: this.rowData.game_id,
            earnest_order_id: this.rowData.id,
          };
          break;
      }
      var { href } = this.$router.resolve({
        name: name,
        query,
      });
      window.open(href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.btn-group {
  height: 46px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
  white-space: nowrap;
  .w-110 {
    width: 110px;
  }
  .button {
    margin-left: 0;
    height: 38px;
    padding: 0 !important;
    div {
      text-align: center;
    }
    .floor_buy {
      transform: translateY(2px);
      height: 16px;
    }
    .floor_price {
      transform: scale(0.9) translateY(-2px);
    }
  }
  .button,
  .el-button {
    & + .el-button {
      margin-left: 0;
    }
    & + .button {
      margin-left: 0;
    }
  }
  .el-button,
  .button {
    min-width: 76px;
    height: 36px;
    flex: 0 0 auto;
    color: var(--text-main, #1A1D24);
    font-size: 12px;
    font-weight: 500;
    padding: 0 16px;
    border-radius: 3px;
    border: 1px solid var(--border-soft, #E8E4DE);
    cursor: pointer;
    background: #FFFFFF;
    transition: color .2s ease, border-color .2s ease, box-shadow .2s ease, opacity .2s ease, background .2s ease;

    &:hover {
      border-color: var(--bg-dark, #1A1D24);
      color: var(--text-main, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
      box-shadow: 0 6px 14px rgba(26, 29, 36, 0.12);
    }

    &.btn-pay {
      border-color: transparent;
      color: #FFFFFF;
      background: var(--primary, #FF5A1F);
      box-shadow: 0 6px 14px rgba(255, 90, 31, 0.18);

      &:hover {
        border-color: transparent;
        color: #FFFFFF;
        background: var(--primary-hover, #E84A12);
        box-shadow: 0 8px 18px rgba(255, 90, 31, 0.22);
      }
    }
  }
  .btn-giveup {
    color: var(--text-secondary, #5A5F6B);
    border-color: var(--border-soft, #E8E4DE);
    background: #fff;
  }
  .btn-price {
    color: var(--text-main, #1A1D24);
    border: 1.5px solid var(--bg-dark, #1A1D24);
    background: #fff;
  }
  .btn-disabled {
    color: var(--text-muted, #9AA0AC);
    background: var(--bg-tag, #F0EDE8);
    border-color: transparent;
    cursor: not-allowed;

    &:hover {
      color: var(--text-muted, #9AA0AC);
      background: var(--bg-tag, #F0EDE8);
      border-color: transparent;
      box-shadow: none;
    }
  }
  .btn-urge-disabled {
    color: var(--text-muted, #9AA0AC);
    background: #fff;
    border-radius: 3px;
    border: 1px solid var(--border-soft, #E8E4DE);
    box-shadow: none;

    &:hover {
      color: var(--text-muted, #9AA0AC);
      background: #fff;
      border-color: var(--border-soft, #E8E4DE);
      box-shadow: none;
    }
  }
  .mr-10 {
    margin-right: 10px;
  }
  .ml-10 {
    margin-left: 10px;
  }
  .word-ative {
    min-height: 24px;
    padding: 3px 10px;
    flex: 0 0 auto;
    color: var(--primary, #FF5A1F);
    letter-spacing: 0.28px;
    font-weight: 400;
    display: flex;
    align-items: center;
    white-space: nowrap;
    background: var(--primary-soft, #FCEDE5);
    border-radius: 4px;
    img {
      width: 17px;
      height: 17px;
    }
    span {
      margin: 0 5px;
    }
  }
}
.counteroffer-msg {
  border-radius: 4px;
  background: #fcf0f0;
  padding: 10px 43px;
  .el-message__icon {
    display: none;
  }
  .el-message__content {
    color: #e47470;
    text-align: center;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
  }
}
</style>
<style lang="less">
.counteroffer-msg {
  border-radius: 4px;
  background: #fcf0f0;
  padding: 10px 43px;
  z-index: 9999999;
  .el-message__icon {
    display: none;
  }
  .el-message__content {
    color: #e47470;
    text-align: center;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
  }
}
</style>
